// eslint-disable-next-line no-unused-vars
import { http, prepareHttpQuery } from 'http';

export default {
  postLoginIdentity: ({ user, password }) =>
    http.post('/login-url', { provider: 'ids', user, password }, { withCredentials: true }),

  postUserSession: payload => http.post('/user-session', payload, { withCredentials: true })
};
